import { memo } from "react";
import { UIMessage } from "ai";

import { Stack } from "@mantine/core";

import ChatMessagePart from "./ChatMessagePart";

import { IRollupProject } from "modules/projects/types/entities";

type ChatMessageProps = {
  message: UIMessage<{ hidden?: boolean }>;
  projects: IRollupProject[];
};

const ChatMessage = (props: ChatMessageProps) => {
  const { message, projects } = props;

  if (message.metadata?.hidden) return null;

  return (
    <Stack gap="xs">
      {message.parts.map((part, index) => (
        <ChatMessagePart
          key={`${message.id}-${part.type}-${index}`}
          part={part}
          role={message.role}
          projects={projects}
        />
      ))}
    </Stack>
  );
};

export default memo(ChatMessage);
